(() => {
  'use strict';

  const PILLOW_TARGET = 'pillow-3d';
  const FORM_ID = 'product-panel-form';

  // ============================================================================
  // Status Constants (from ImageTaskModule)
  // ============================================================================
  const STATUS = window.ImageTaskModule?.STATUS || {
    PENDING: 'pending',
    SUCCESS: 'success',
    ERROR: 'error',
    SKIP: 'skip'
  };
  const EVENT_TYPES = {
    FULL: 'full',
    HISTORY: 'history',
    COLOR_CHANGE: 'color'
  };

  // ============================================================================
  // Event Names
  // ============================================================================
  const EVENT_NAMES = {
    PILLOW3D: 'pillow3d',
    SAVE_TO_S3: 'saveToS3'
  };

  // ============================================================================
  // Events
  // ============================================================================
  const EVENTS = {
    PROCESSING_INIT: 'imageTask:init',
    PROCESSING_STARTED: 'imageTask:started',
    PROCESSING_SUCCESS: 'imageTask:success',
    PROCESSING_ERROR: 'imageTask:error',
    COLOR_INIT: 'imageTask:colorInit'
  };

  // ============================================================================
  // Gemini Coloring Pillow
  // ============================================================================
function startColoringLoader() {
  const percentElement = document.getElementById('loader-percentage');
  let currentPercent = 0;
  let startTime = Date.now();

  const updateProgress = () => {
    const elapsed = (Date.now() - startTime) / 1000; 

    if (elapsed <= 25) {
    
      currentPercent = (elapsed / 25) * 80;
    } else if (elapsed <= 55) {
      const phase2Elapsed = elapsed - 25;
      currentPercent = 80 + (phase2Elapsed / 30) * 20;
    } else {
      currentPercent = 100;
    }

    percentElement.textContent = Math.floor(currentPercent) + '%';

    if (currentPercent < 100) {
      requestAnimationFrame(updateProgress);
    }
  };

  requestAnimationFrame(updateProgress);
}

// const processWithGemini = async (file) => {
//   console.log('Lambda Integration START');
  
//   const LAMBDA_URL = 'https://5plobe71jb.execute-api.us-west-1.amazonaws.com/image-transforms/coloring';

//   try {

//     const base64Data = await new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result.split(',')[1]);
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });

   
//     const requestBody = {
//       base64Data: base64Data,
//       mimeType: file.type 
//     };

    
//     const response = await fetch(LAMBDA_URL, {
//       method: 'POST',
//       headers: { 
//         'Content-Type': 'application/json'

//       },
//       body: JSON.stringify(requestBody)
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(`Lambda error: ${response.status} - ${errorText}`);
//     }

//     const result = await response.json();

 
//     if (!result.success || !result.output?.data) {
//       console.error("error answer", result);
//       throw new Error('no image');
//     }

//     const imageData = result.output.data;
//     const mimeType = result.output.mime_type || 'image/png';

//     const byteCharacters = atob(imageData);
//     const byteNumbers = new Array(byteCharacters.length);
//     for (let i = 0; i < byteCharacters.length; i++) {
//       byteNumbers[i] = byteCharacters.charCodeAt(i);
//     }
//     const byteArray = new Uint8Array(byteNumbers);
//     const blob = new Blob([byteArray], { type: mimeType });

//     return new File([blob], `coloring_${file.name}`, { type: mimeType });

//   } catch (e) {
//     console.error("[Lambda Adapter Error]:", e);
//     return file; 
//   }
// };

const MAX_FILE_SIZE_BYTES = 4 * 1024 * 1024; // 4 MB
const MAX_DIMENSION = 2048; 
const COMPRESSION_QUALITY = 0.9;

const compressImage = async (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = reject;

    img.onload = () => {
    
      let width = img.width;
      let height = img.height;

      if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        if (width > height) {
          height = Math.round((height * MAX_DIMENSION) / width);
          width = MAX_DIMENSION;
        } else {
          width = Math.round((width * MAX_DIMENSION) / height);
          height = MAX_DIMENSION;
        }
      }


      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      
      
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

  
      const dataUrl = canvas.toDataURL('image/jpeg', COMPRESSION_QUALITY);
      
      resolve({
        base64Data: dataUrl.split(',')[1], // Відрізаємо метадані
        mimeType: 'image/jpeg'
      });
    };

    reader.readAsDataURL(file);
  });
};

const processWithGemini = async (file) => {
  console.log('Lambda Integration START');
  
  const LAMBDA_URL = 'https://fxnctivc3vrtur2al7fvuzh3ry0jwkws.lambda-url.us-west-1.on.aws/image-transforms/new-coloring';

  try {
    let base64Data;
    let mimeTypeAI;

    if (file.size > MAX_FILE_SIZE_BYTES) {
        console.log(`Image is too large (${(file.size / 1024 / 1024).toFixed(2)} MB). Compressing...`);
        const compressed = await compressImage(file);
        base64Data = compressed.base64Data;
        mimeTypeAI = compressed.mimeType;
        console.log('Compression complete.');
    } else {
        mimeTypeAI = file.type;
        base64Data = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    const requestBody = {
      base64Data: base64Data,
      mimeType: mimeTypeAI
    };
    
    const response = await fetch(LAMBDA_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Lambda error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
 
    if (!result.success || !result.output?.data) {
      console.error("error answer", result);
      throw new Error('no image');
    }


    const imageData = result.output.data;
    const mimeType = result.output.mime_type || 'image/png';

    const byteCharacters = atob(imageData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const initialBlob = new Blob([byteArray], { type: mimeType });

    const imgBitmap = await createImageBitmap(initialBlob);
    
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { alpha: true }); 

    const width = imgBitmap.width;
    const height = imgBitmap.height;

  
    const paddingX = Math.round(width * 0.10);
    const paddingY = Math.round(height * 0.10);

    canvas.width = width + (paddingX * 2);
    canvas.height = height + (paddingY * 2);

  
    

    // ctx.drawImage(imgBitmap, 0, 0);
    // const pixelData = ctx.getImageData(0, 0, 1, 1).data;
  
    // const bgColor = `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
    
 
    // ctx.fillStyle = bgColor;
    // ctx.fillRect(0, 0, canvas.width, canvas.height);


    ctx.drawImage(imgBitmap, paddingX, paddingY, width, height);

 
    const finalBlob = await new Promise((resolve) => {
     
        canvas.toBlob(resolve, mimeType, 1.0);
    });

    imgBitmap.close(); 

    return new File([finalBlob], `coloring_framed_${file.name}_${new Date().getTime()}`, { type: mimeType });



  } catch (e) {
    console.error("[Lambda Adapter Error]:", e);
    throw e
  }
};

  // ============================================================================
  // External Module Adapters
  // ============================================================================

  const ImageTaskAdapter = {
    create: (originalFileId, color, historyId) => {
      if (!window.ImageTaskModule?.create) {
        console.error('[ImageTaskAdapter] ImageTaskModule not available - ensure image-task-module.js is loaded before section-main-shaped.js');
        return null;
      }
      return window.ImageTaskModule.create(originalFileId, color, historyId);
    },
    update: (task, updates) => {
      if (!window.ImageTaskModule?.update) {
        console.warn('[ImageTaskAdapter] ImageTaskModule.update not available');
        return null;
      }
      return window.ImageTaskModule.update(task, updates);
    },
    updateForColorChange: (task, newColor) => {
      if (!window.ImageTaskModule?.updateForColorChange) {
        console.warn('[ImageTaskAdapter] ImageTaskModule.updateForColorChange not available');
        return null;
      }
      return window.ImageTaskModule.updateForColorChange(task, newColor);
    },
    generateFileOriginalId: (file) => {
      if (!window.ImageTaskModule?.generateFileOriginalId) {
        console.warn('[ImageTaskAdapter] ImageTaskModule.generateFileOriginalId not available');
        return null;
      }
      return window.ImageTaskModule.generateFileOriginalId(file);
    }
  };

  const ProductFormAdapter = {
    setOriginalImage: (url) => {
      if (!window.ProductFormCustom?.setOriginalImage) {
        console.warn('[ProductFormAdapter] ProductFormCustom.setOriginalImage not available');
        return;
      }
      return window.ProductFormCustom.setOriginalImage(FORM_ID, url);
    },
    setMockup: (preview) => {
      if (!window.ProductFormCustom?.setMockup) {
        console.warn('[ProductFormAdapter] ProductFormCustom.setMockup not available');
        return;
      }
      return window.ProductFormCustom.setMockup(FORM_ID, preview);
    },
    clearImageData: () => {
      if (!window.ProductFormCustom?.clearImageData) {
        console.warn('[ProductFormAdapter] ProductFormCustom.clearImageData not available');
        return;
      }
      return window.ProductFormCustom.clearImageData(FORM_ID);
    },
    clearCroppingNotes: () => {
      if (!window.ProductFormCustom?.clearCroppingNotes) {
        console.warn('[ProductFormAdapter] ProductFormCustom.clearCroppingNotes not available');
        return false;
      }
      return window.ProductFormCustom.clearCroppingNotes(FORM_ID);
    },
    getCurrentColor: () => {
      if (!window.ProductFormCustom?.getCurrentColor) {
        console.warn('[ProductFormAdapter] ProductFormCustom.getCurrentColor not available');
        return null;
      }
      return window.ProductFormCustom.getCurrentColor(FORM_ID) || null;
    },
    updateColor: (color, options = {}) => {
      if (!window.ProductFormCustom?.updateColor) {
        console.warn('[ProductFormAdapter] ProductFormCustom.updateColor not available');
        return;
      }
      return window.ProductFormCustom.updateColor(FORM_ID, color, options);
    },
    enableButtons: () => {
      if (!window.ProductFormCustom?.enableButton) {
        console.warn('[ProductFormAdapter] ProductFormCustom.enableButton not available');
        return;
      }
      return window.ProductFormCustom.enableButton(FORM_ID);
    },
    disableButtons: () => {
      if (!window.ProductFormCustom?.disableButton) {
        console.warn('[ProductFormAdapter] ProductFormCustom.disableButton not available');
        return;
      }
      return window.ProductFormCustom.disableButton(FORM_ID);
    },
    getProductTitle: () => {
      if (!window.ProductFormCustom?.getProductTitle) {
        console.warn('[ProductFormAdapter] ProductFormCustom.getProductTitle not available');
        return '';
      }
      return window.ProductFormCustom.getProductTitle(FORM_ID) || '';
    },
    getCurrentSku: () => {
      if (!window.ProductFormCustom?.getCurrentSku) {
        console.warn('[ProductFormAdapter] ProductFormCustom.getCurrentSku not available');
        return '';
      }
      return window.ProductFormCustom.getCurrentSku(FORM_ID) || '';
    },
    getCurrentTemplate: () => {
      if (!window.ProductFormCustom?.getCurrentTemplate) {
        console.warn('[ProductFormAdapter] ProductFormCustom.getCurrentTemplate not available');
        return '';
      }
      return window.ProductFormCustom.getCurrentTemplate(FORM_ID) || '';
    }
  };

  const Pillow3DAdapter = {
    getEl: () => window.Pillow3D?.getEl?.() || $(PILLOW_TARGET).first().get(0) || null,
    setSrc: (dataUrl) => {
      const el = Pillow3DAdapter.getEl();
      if (!el) return;
      requestAnimationFrame(() => {
        if (window.Pillow3D?.setSrc) {
          window.Pillow3D.setSrc(dataUrl);
        } else {
          $(el).attr('src', dataUrl);
        }
      });
    },
    setColor: (color) => {
      if (!window.Pillow3D?.setColor) {
        console.warn('[Pillow3DAdapter] Pillow3D.setColor not available');
        return;
      }
      return window.Pillow3D.setColor(color);
    },
    setPillowData: (data, color) => {
      if (!window.Pillow3D?.setPillowData) {
        console.warn('[Pillow3DAdapter] Pillow3D.setPillowData not available');
        return;
      }
      return window.Pillow3D.setPillowData(data, color);
    },
    abort: () => {
      if (!window.Pillow3D?.abort) {
        console.warn('[Pillow3DAdapter] Pillow3D.abort not available');
        return;
      }
      return window.Pillow3D.abort();
    },
    abort: () => {
      if (!window.Pillow3D?.abort) {
        console.warn('[Pillow3DAdapter] Pillow3D.abort not available');
        return;
      }
      return window.Pillow3D.abort();
    }
  };

  const SaveToS3Adapter = {
    saveImg: (dataUrl, fileType) => {
      if (!window.SaveToS3?.saveImg) {
        console.warn('[SaveToS3Adapter] SaveToS3.saveImg not available');
        return null;
      }

      return window.SaveToS3.saveImg(dataUrl, fileType);
    },
    abort: () => {
      if (!window.SaveToS3?.abort) {
        console.warn('[SaveToS3Adapter] SaveToS3.abort not available');
        return;
      }
      return window.SaveToS3.abort();
    }
  };

  const FileHistoryAdapter = {
    useFromHistory: (fileOriginalId, s3Url, color) => {
      if (!window.FileHistoryManager?.useFromHistory) {
        console.warn('[FileHistoryAdapter] FileHistoryManager.useFromHistory not available');
        return {
          fileId: null,
          s3Url: null,
          pillowData: null,
          preview: null,
          previewWithBg: null
        };
      }
      return window.FileHistoryManager.useFromHistory(fileOriginalId, s3Url, color);
    },
    createHistoryItem: (data) => {
      if (!window.FileHistoryManager?.createHistoryItem) {
        console.warn('[FileHistoryAdapter] FileHistoryManager.createHistoryItem not available');
        return null;
      }
      return window.FileHistoryManager.createHistoryItem(data);
    },
    generateFileId: (name, size, lastModified, color) => {
      // Generate fileId using same logic as FileHistoryManager
      if (!name || !color) return null;
      if (typeof size !== 'number' || typeof lastModified !== 'number') return null;
      const originalId = `${name}_${size}_${lastModified}`;
      return `${originalId}_${color}`;
    },
    getCurrentFile: () => {
      if (!window.FileHistoryManager?.getCurrentFile) {
        console.warn('[FileHistoryAdapter] FileHistoryManager.getCurrentFile not available');
        return null;
      }
      return window.FileHistoryManager.getCurrentFile() || null;
    },
    setCurrentFile: (fileId) => {
      if (!window.FileHistoryManager?.setCurrentFile) {
        console.warn('[FileHistoryAdapter] FileHistoryManager.setCurrentFile not available');
        return null;
      }
      return window.FileHistoryManager.setCurrentFile(fileId);
    },
    getFileByOriginalId: (originalFileId) => {
      if (!window.FileHistoryManager?.getFileByOriginalId) {
        console.warn('[FileHistoryAdapter] FileHistoryManager.getFileByOriginalId not available');
        return null;
      }
      return window.FileHistoryManager.getFileByOriginalId(originalFileId);
    }
  };

  const SizeMockupsAdapter = {
    clear: () => {
      if (!window.SizeMockups?.clear) {
        console.warn('[SizeMockupsAdapter] SizeMockups.clear not available');
        return;
      }
      return window.SizeMockups.clear();
    },
    hideWidget: () => {
      if (!window.SizeMockups?.hideWidget) {
        console.warn('[SizeMockupsAdapter] SizeMockups.hideWidget not available');
        return;
      }
      return window.SizeMockups.hideWidget();
    },
    generateAndShow: (preview) => {
      if (!window.SizeMockups?.generateAndShow) {
        console.warn('[SizeMockupsAdapter] SizeMockups.generateAndShow not available');
        return;
      }
      return window.SizeMockups.generateAndShow(preview);
    }
  };

  const VariantPickerAdapter = {
    setImages: (preview, selector) => {
      if (!window.VariantPickerCustom?.setImages) {
        console.warn('[VariantPickerAdapter] VariantPickerCustom.setImages not available');
        return;
      }
      return window.VariantPickerCustom.setImages(preview, selector);
    },
    clearImages: (selector) => {
      if (!window.VariantPickerCustom?.clearImages) {
        console.warn('[VariantPickerAdapter] VariantPickerCustom.clearImages not available');
        return;
      }
      return window.VariantPickerCustom.clearImages(selector || '[data-variant-picker-custom]');
    }
  };

  const MockupErrorBlockAdapter = {
    show: (opts = {}) => {
      if (window.MockupErrorBlock?.show) {
        window.MockupErrorBlock.show(opts);
      } else {
        console.warn('[MockupErrorBlockAdapter] window.MockupErrorBlock not available yet');
      }
    },
    hide: () => {
      if (window.MockupErrorBlock?.hide) {
        window.MockupErrorBlock.hide();
      }
    }
  };

  const AnalyticsAdapter = {
    init: (config = {}) => {
      if (!window.AnalyticsModule?.create) {
        console.warn('[AnalyticsAdapter] AnalyticsModule not available - analytics tracking disabled');
        return false;
      }
      window.AnalyticsModule.create(config);
      return true;
    },

    start: (options = {}) => {
      if (!window.AnalyticsModule?.start) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.start not available');
        return;
      }
      window.AnalyticsModule.start(options);
    },

    endProcess: (status, options = {}) => {
      if (!window.AnalyticsModule?.endProcess) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.endProcess not available');
        return;
      }
      window.AnalyticsModule.endProcess(status, options);
    },

    startMockup: () => {
      if (!window.AnalyticsModule?.startMockup) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.startMockup not available');
        return;
      }
      window.AnalyticsModule.startMockup();
    },

    endMockup: (preview = null, colorEvent = false) => {
      if (!window.AnalyticsModule?.endMockup) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.endMockup not available');
        return;
      }
      window.AnalyticsModule.endMockup(preview, colorEvent);
    },

    startSave: () => {
      if (!window.AnalyticsModule?.startSave) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.startSave not available');
        return;
      }
      window.AnalyticsModule.startSave();
    },

    endSave: (url = null) => {
      if (!window.AnalyticsModule?.endSave) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.endSave not available');
        return;
      }
      window.AnalyticsModule.endSave(url);
    },

    setLogging: (enabled) => {
      if (!window.AnalyticsModule?.setLogging) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.setLogging not available');
        return;
      }
      window.AnalyticsModule.setLogging(enabled);
    },

    toCart: () => {
      if (!window.AnalyticsModule?.toCart) {
        console.warn('[AnalyticsAdapter] AnalyticsModule.toCart not available');
        return;
      }

      const productSku = ProductFormAdapter.getCurrentSku();
      window.AnalyticsModule.toCart(productSku);
    }
  };

  const ImageUploadAdapter = {
    open: () => {
      const api = window.ImageUploadInput;
      if (!api) {
        console.warn('[ImageUploadAdapter] ImageUploadInput not available');
        return;
      }
      if (api.openForTarget) return api.openForTarget(PILLOW_TARGET);
      if (api.open) return api.open();
      console.warn('[ImageUploadAdapter] ImageUploadInput.openForTarget and open not available');
    },
    clear: () => {
      const api = window.ImageUploadInput;
      if (!api) {
        console.warn('[ImageUploadAdapter] ImageUploadInput not available');
        return;
      }
      if (api.clear) return api.clear();
      if (api.clearForTarget) return api.clearForTarget(PILLOW_TARGET);
      console.warn('[ImageUploadAdapter] ImageUploadInput.clear and clearForTarget not available');
    }
  };



  // ============================================================================
  // UI Service - handles UI updates (mockups, variant picker, Pillow3D, errors)
  // ============================================================================
  const UIService = {
    // Preview updates (UI elements only)
    updatePreview: (preview) => {
      if (!preview) return;
      SizeMockupsAdapter.generateAndShow(preview);
      VariantPickerAdapter.setImages(preview, '[data-variant-picker-custom]');
      UIService.showVariantPicker();
      UIService.slideDownEditButtonsPanel();
    },

    updatePillowData: (data, color) => {
      if (data && color) {
        Pillow3DAdapter.setPillowData(data, color);
      }
      else{
        throw new Error('data and color are required');
      }
    },

    setPillow3dSrc: (dataUrl) => {
      Pillow3DAdapter.setSrc(dataUrl);
    },

    setPillow3dColor: (color) => {
      Pillow3DAdapter.setColor(color);
    },

    showError: (type) => {
      MockupErrorBlockAdapter.show({
        type
      });
    },

    hideError: () => {
      MockupErrorBlockAdapter.hide();
    },

    mapErrorTypeToUIType: (errorType) => {
      const rawType = String(errorType || '').toLowerCase();

      if (rawType.includes('removebg')) {
        return 'removebg';
      }

      if (rawType.includes('network') || rawType.includes('save') || rawType.includes('s3')) {
        return 'network';
      }

      if (rawType.includes('pillow') || rawType.includes('mockup')) {
        return 'mockup';
      }

      return 'unknown';
    },
    showVariantPicker: () => {
      $('#product-panel-form').slideDown();
     
    },

    slideDownEditButtonsPanel: () => {
      const $editButtonsPanel = $('[data-edit-buttons-panel]');
      if ($editButtonsPanel.length && $editButtonsPanel.css('display') === 'none') {
        setTimeout(() => {
          $editButtonsPanel.slideDown(300);
        }, 3000);
      }
    },

    // Get sections to hide on home page - returns sections whose ID contains any of the section names
    getSectionsToHide: () => {
      const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';
      if (!isHomePage) {
        return $();
      }

      const $mainContent = $('#MainContent');
      if (!$mainContent.length) {
        return $();
      }

      // Get all sections
      const $allSections = $mainContent.find('.shopify-section');
      if ($allSections.length === 0) {
        return $();
      }

      // Array of section names - return sections that contain these names in their ID
      const sectionNames = [
        'brand_logos',
        'multicolumn_cards', 
      ];

      // Filter sections to hide - return sections whose ID contains any of the section names
      const $sectionsToHide = $allSections.filter(function() {
        const $section = $(this);
        const sectionId = $section.attr('id') || '';
        return sectionNames.some(name => sectionId.includes(name));
      });

      return $sectionsToHide;
    },

    showProductBlock: () => {
      $('[product-block]').removeClass('hide').css('display', '');
      $('[data-block-id="product-panel"]').removeClass('hide').css('display', '');
      $('[data-block-id="product-info"]').addClass('hide');
      $('.js-hidden-mockup').removeClass('hide');
      // Hide desktop preload overlay (main product page)
      $('[data-main-product-preloader]').addClass('hide');
      
      // Hide sections on home page
      const $sectionsToHide = UIService.getSectionsToHide();
      $sectionsToHide.addClass('hide').css('display', 'none');
      $('.video-story-block--two-buttons').addClass('hide')
      $('.c-post__btn').addClass('hide')
    

      window.scrollTo({
        top: 74,
        behavior: 'smooth'
      });

    
     
    },

    hideProductBlock: () => {
      $('[product-block]').addClass('hide');
      $('[data-block-id="product-panel"]').addClass('hide');
      $('[data-block-id="product-info"]').removeClass('hide');
      $('.js-hidden-mockup').addClass('hide');
    
      
      // Show all hidden sections on home page
      const $mainContent = $('#MainContent');
      if ($mainContent.length) {
        const $hiddenSections = $mainContent.find('.shopify-section.hide');
        $hiddenSections.removeClass('hide').css('display', '');
        $('.video-story-block--two-buttons').removeClass('hide')
        $('.c-post__btn').removeClass('hide')
       
      }
    },

    toggleProductBlock: () => {
      const $panel = $('[product-block]');
      if ($panel.hasClass('hide')) {
        $panel.removeClass('hide').css('display', '');
      } else {
        $panel.addClass('hide');
      }
    },

    clearSizeMockups: () => {
      SizeMockupsAdapter.clear();
    },

    hideSizeMockupsWidget: () => {
      SizeMockupsAdapter.hideWidget();
    },

    clearVariantPicker: () => {
      VariantPickerAdapter.clearImages();
    },
    clearPreview: () => {
      UIService.clearVariantPicker();
      UIService.hideSizeMockupsWidget();
      UIService.clearVariantPicker();
    },
    reset: () => {
      UIService.clearSizeMockups();
      UIService.hideSizeMockupsWidget();
      UIService.clearVariantPicker();
      UIService.showProductBlock();
    },
    //TODO add more logic, update functions, remove html
    showAILoader: (message) => {
        $('.coloring-loader-info').removeClass('hidden');
        startColoringLoader()
    },

    hideAILoader: () => {
      setTimeout(() => {
        $('.coloring-loader-info').addClass('hidden');
      }, 300);
    }
  };


  // ============================================================================
  // Image Processing Manager
  // ============================================================================
  const ImageProcessingManager = (() => {
    const state = {
      imageTask: null,
      prevImageTask: null,
      firstUpload: true
    };


    // ============================================================================
    // State Coordinator
    // Coordinates updates across Task, Form, and UI layers
    // ============================================================================
    const StateCoordinator = (() => {
      // Private helper: Update task data
      const updateTask = (updates) => {
        if (!state.imageTask) return false;
        const currentTaskId = state.imageTask.id;
        const updated = ImageTaskAdapter.update(state.imageTask, updates, currentTaskId);
        if (updated) {
          state.imageTask = updated;
          return true;
        }
        return false;
      };

      // Save previous task 
      const savePrevTask = () => {
        if (state.imageTask) {
          state.prevImageTask = JSON.parse(JSON.stringify(state.imageTask));
        }
      };

      // Update task for color change (internal) - updates: Task only
      const updateImageTaskForColorChange = (newColor) => {
        if (!newColor || !state.imageTask) {
          error('unknown');
          return;
        }
        const updatedTask = ImageTaskAdapter.updateForColorChange(state.imageTask, newColor, state.imageTask.id);
        if (updatedTask) {
          state.imageTask = updatedTask;
        }
      };

      const setPillowSrc = (dataUrl) => {
      
        updateTask({
          dataUrl
        });
        UIService.setPillow3dSrc(dataUrl);
      };

      const setS3Url = (url) => {
        updateTask({
          s3Url: url
        });
        ProductFormAdapter.setOriginalImage(url);
      };

      const savePillowData = (data) => {
        updateTask({
          pillowData: data
        });
      };

      const setPillowData = (data, color) => {
        savePillowData(data);
        UIService.updatePillowData(data, color);
      };

      const setColor = (color, formUpdate = false, options = {}) => {
        updateImageTaskForColorChange(color);
        if (formUpdate) {
          ProductFormAdapter.updateColor(color, options);
        }
        UIService.setPillow3dColor(color);
      };

      const setPreview = (preview, previewWithBg = null) => {

        const updates = {
          preview: preview,
          previewWithBg: previewWithBg
        };
        updateTask(updates);
        const mockup = previewWithBg || preview;
        ProductFormAdapter.setMockup(mockup);
        if (!preview) {
          UIService.clearPreview();
        } else {
          UIService.updatePreview(preview);
        }
      };

      const clearPillowData = () => {
        updateTask({
          pillowData: null
        });
      };

      const setPillow3dState = (status) => {
        updateTask({
          status: {
            ...state.imageTask.status,
            pillow3d: status
          }
        });
      };

      const setSaveToS3State = (status) => {

        updateTask({
          status: {
            ...state.imageTask.status,
            saveToS3: status
          }
        });
      };

      const clearFileData = () => {

        updateTask({
          s3Url: null,
          pillowData: null,
          preview: null
        });

        ProductFormAdapter.clearImageData();
      };

      const clearState = () => {
        savePrevTask();
        state.imageTask = null;
        ProductFormAdapter.clearImageData();
        UIService.reset();
        ProductFormAdapter.clearCroppingNotes();
      };

      const initialState = () => {
        clearState();
        UIService.hideError();
        UIService.hideProductBlock();
        ImageUploadAdapter.clear();
      };

      const defaultState = () => {
        clearState();
        UIService.hideError();
      };

      const error = (type) => {
        UIService.showError(type);
        clearState();
      };

      return {
        setPillowSrc: (dataUrl) => setPillowSrc(dataUrl),
        setS3Url: (url) => setS3Url(url),
        setPillowData: (data, color) => setPillowData(data, color),
        setColor: (color, formUpdate) => setColor(color, formUpdate),
        setPreview: (preview, previewWithBg) => setPreview(preview, previewWithBg),

        // Status setters
        setPillow3dState: (status) => setPillow3dState(status),
        setSaveToS3State: (status) => setSaveToS3State(status),


        savePillowData: (data) => savePillowData(data),

        // Clear methods
        clearPillowData: () => clearPillowData(),
        clearFileData: () => clearFileData(),
        clearState: () => clearState(),
        defaultState: () => defaultState(),
        initialState: () => initialState(),
      

        // Error handling
        error: (type) => error(type)
      };
    })();


    // ============================================================================
    // Status Management
    // ============================================================================
    const StatusManager = (() => {
      const processInit = (file, s3Url, dataUrl, fromHistory = false) => {
        ProductFormAdapter.disableButtons();
        StateCoordinator.defaultState();

        EventService.dispatch(EVENTS.PROCESSING_INIT, {
          file: file ? {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
          } : null,
          s3Url: s3Url,
          fromHistory: fromHistory
        });


      };

      const colorStart = (colorValue) => {
        ProductFormAdapter.disableButtons();
        StateCoordinator.setPreview(null);
        saveToS3Completed(null, STATUS.SKIP);

        EventService.dispatch(EVENTS.COLOR_INIT, {
          colorValue: colorValue
        });
      };

      const processStarted = (task, data, state, file) => {
        const imageType = file?.type || 'image/jpeg';
        EventService.dispatch(EVENTS.PROCESSING_STARTED, {
          imageTask: task,
          cachedS3Url: data.s3Url,
          cachedPillowData: data.pillowData,
          cachedPreview: data.preview,
          cachedPreviewWithBg: data.previewWithBg,
          imageType: imageType,
          file: file ? {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
          } : null
        }, state);
      };

      const processEnd = () => {
        ProductFormAdapter.enableButtons();
      };

      const processError = (errorType) => {
        StateCoordinator.error(errorType);
        ProductFormAdapter.enableButtons();
      };

      const abortPending = (imageTask) => {
        console.log('ABORT PENDING', imageTask.status.pillow3d, imageTask.status.saveToS3);
        if (imageTask?.status.pillow3d === STATUS.PENDING) Pillow3DAdapter.abort();
        if (imageTask?.status.saveToS3 === STATUS.PENDING) SaveToS3Adapter.abort();
      };

      const mockupCompleted = (pillowData, preview, previewWithBg = null, status = STATUS.SUCCESS) => {
        StateCoordinator.setPillow3dState(status);
        StateCoordinator.savePillowData(pillowData);
        StateCoordinator.setPreview(preview, previewWithBg);
      };

      const mockupError = () => {
        StateCoordinator.setPillow3dState(STATUS.ERROR);
      };

      const saveToS3Completed = (url, status = STATUS.SUCCESS) => {
        StateCoordinator.setSaveToS3State(status);
        if (url) {
          StateCoordinator.setS3Url(url);
        }
      };

      const saveToS3Error = () => {
        console.log('SAVE TO S3 ERROR', STATUS);
        StateCoordinator.setSaveToS3State(STATUS.ERROR);
      };

      const checkAllCompleted = () => {
        if (!state.imageTask) return false;
        const pillow3dDone = state.imageTask.status.pillow3d === STATUS.SUCCESS ||
          state.imageTask.status.pillow3d === STATUS.SKIP;
        const saveToS3Done = state.imageTask.status.saveToS3 === STATUS.SUCCESS ||
          state.imageTask.status.saveToS3 === STATUS.SKIP;
        const allSuccess = pillow3dDone && saveToS3Done;
        const anyError = state.imageTask.status.pillow3d === STATUS.ERROR ||
          state.imageTask.status.saveToS3 === STATUS.ERROR;
         

        if (allSuccess) {
          if (state.firstUpload) state.firstUpload = false;
          processEnd();
          EventService.dispatch(EVENTS.PROCESSING_SUCCESS, {
            imageTask: state.imageTask
          }, state);

          return true;
        }

        if (anyError) {
          abortPending(state.imageTask);
         
          processEnd();

          return true;
        }

        return false;
      };

      const markEventSuccess = (eventName, data = {}, status = STATUS.SUCCESS) => {
        if (eventName === EVENT_NAMES.PILLOW3D) {
          const {
            pillowData,
            preview,
            previewWithBg = null
          } = data;
          mockupCompleted(pillowData, preview, previewWithBg, status);
        }
        if (eventName === EVENT_NAMES.SAVE_TO_S3) {
          const {
            url = null
          } = data;
          saveToS3Completed(url, status);
        }
        checkAllCompleted();
      }; 

      const markEventError = (eventName, errorType, data = {}) => {
        if (eventName === EVENT_NAMES.PILLOW3D)
         {
          mockupError();
         }
        if (eventName === EVENT_NAMES.SAVE_TO_S3)
         {
          saveToS3Error();
         }
       
      
        checkAllCompleted();
        EventService.dispatch(EVENTS.PROCESSING_ERROR, {
          imageTask: state.imageTask,
          errorType: errorType
        }, state);

        processError(errorType);
      };

      return {
        processInit: (file, s3Url, dataUrl, fromHistory = false) => processInit(file, s3Url, dataUrl, fromHistory),
        colorStart: (colorValue) => colorStart(colorValue),
        processStarted: (task, data, state, file) => processStarted(task, data, state, file),
        processEnd: () => processEnd(),
        processError: (errorType) => processError(errorType),
        abortPending: (imageTask) => abortPending(imageTask),
        mockupCompleted: (pillowData, preview, previewWithBg, status) => mockupCompleted(pillowData, preview, previewWithBg, status),
        mockupError: () => mockupError(),
        saveToS3Completed: (url, status) => saveToS3Completed(url, status),
        saveToS3Error: () => saveToS3Error(),
        checkAllCompleted: () => checkAllCompleted(),
        markEventSuccess: (eventName, data, status) => markEventSuccess(eventName, data, status),
        markEventError: (eventName, errorType, data) => markEventError(eventName, errorType, data)
       
      };
    })();

    // ============================================================================
    // ============================================================================
    // Validation & Checks
    // ============================================================================
    const validateInputs = (file, s3Url) => {
      if (!file && !s3Url) {
        throw new Error('either file or s3Url must be provided');
      }
    };

    const needsPillowProcess = (cachedPillowData, cachedPreview, firstUpload) => {
      // Skip processing if we have cached data AND preview AND it's not the first upload
      const hasCachedData = cachedPillowData && cachedPreview;
      const canUseCache = hasCachedData && !firstUpload;

      return !canUseCache;
    };

    // ============================================================================
    // History Resolution
    // ============================================================================
    const createDataObject = (fileOriginalId, s3Url, dataUrl) => {
      const currentColor = ProductFormAdapter.getCurrentColor();
      const history = FileHistoryAdapter.useFromHistory(fileOriginalId, s3Url, currentColor) || {};
  
      return {
        history,
        fileId: history.fileId || null,
        finalS3Url: s3Url ||history.s3Url || null,
        finalPillowData: history.pillowData || null,
        finalPreview: history.preview || null,
        finalPreviewWithBg: history.previewWithBg || null,
        finalDataUrl: history.dataUrl || dataUrl|| null,
        color: currentColor,
        fileOriginalId: history.fileOriginalId | fileOriginalId || null
      };
    };

    const checklInHistory = (fileOriginalId, s3Url, dataUrl) => {
      const currentColor = ProductFormAdapter.getCurrentColor();
      const history = FileHistoryAdapter.useFromHistory(fileOriginalId, s3Url, currentColor) || {};
      return history;
    };

    // ============================================================================
    // Task Management
    // ============================================================================
    const createAndSetTask = (file, color, fileId, fileOriginalId ) => {
      const fileOriginalIdValid = fileOriginalId || (file ? ImageTaskAdapter.generateFileOriginalId(file) : null);
      const imageTask = ImageTaskAdapter.create(fileOriginalIdValid, color, fileId);
      if (!imageTask) {
        throw new Error('failed to create image task - ImageTaskModule may not be loaded');
      }

      state.imageTask = imageTask;
      return imageTask;
    };

    // ============================================================================
    // Error Handling
    // ============================================================================
    const handleProcessingError = (message, functionName) => {
      console.error(`[ImageProcessingManager:${functionName}] ${message}`);
      StateCoordinator.error('unknown');
    };

    // ============================================================================
    // Operation Handlers
    // ============================================================================
    const handleS3Upload = (s3Url, dataUrl, fileType) => {
      if (s3Url && !state.firstUpload) {
        StatusManager.markEventSuccess(EVENT_NAMES.SAVE_TO_S3, {
          url: s3Url  
        }, STATUS.SKIP);
       
      } else {
        if (!dataUrl) {
          throw new Error('dataUrl is required for S3 upload');
        }
        SaveToS3Adapter.saveImg(dataUrl, fileType);
      }
    };


    const handlePillowProcess = (color, pillowData, preview, previewWithBg, dataUrlToUse) => {
   
      const shouldProcess = needsPillowProcess(pillowData, preview, state.firstUpload);
 
      if (!shouldProcess) {
        StateCoordinator.setPillowData(pillowData, color);
        setTimeout(() => {
          StatusManager.markEventSuccess(EVENT_NAMES.PILLOW3D, {
            pillowData,
            preview,
            previewWithBg
          }, STATUS.SKIP);
        }, 1000);
      } else {
        if (!dataUrlToUse) {
          throw new Error('dataUrl is required for Pillow3D processing');
        }
        StateCoordinator.setPillowSrc(dataUrlToUse);
      }
    };



    // ============================================================================
    // Main Processing Functions
    // ============================================================================
    const start = async(file = null, s3Url = null, dataUrl = null, fromHistory = false) => {
      try {
       
        UIService.showProductBlock();
        StatusManager.processInit(file, s3Url, dataUrl, fromHistory);
        
        let originFile = file;
        let fileOriginalId = originFile ? ImageTaskAdapter.generateFileOriginalId(originFile) : null;
   

        const isInHistory = checklInHistory(fileOriginalId, s3Url, dataUrl);
       
        if ((file && !isInHistory.s3Url && !isInHistory.pillowData) || (state.firstUpload && file)) {
           
            UIService.showAILoader("Converting image...");
            file = await processWithGemini(file);
            // Оновлюємо dataUrl, щоб прев'ю теж було новим
            dataUrl = await new Promise(resolve => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.readAsDataURL(file);
            });
            UIService.hideAILoader();
            if (state.firstUpload && isInHistory.s3Url && isInHistory.pillowData){
              originFile = file;
              fileOriginalId = originFile ? ImageTaskAdapter.generateFileOriginalId(originFile) : null;
            }
        }

       
        validateInputs(file, s3Url);
   
        // Read file to dataUrl if file provided and no dataUrl
        const readFilePromise = file && !dataUrl ?
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = () => reject(new Error('Failed to read file'));
            reader.readAsDataURL(file);
          }) :
          Promise.resolve(dataUrl);

        readFilePromise.then((readedDataUrl) => {
          const processData = createDataObject(fileOriginalId, s3Url, readedDataUrl);
          const { finalS3Url, finalPillowData, finalPreview, finalPreviewWithBg, finalDataUrl, color, fileId } = processData;
          const task = createAndSetTask(originFile, color, fileId, fileOriginalId);

          handleS3Upload(
            finalS3Url,
            finalDataUrl,
            file?.type || 'image/jpeg'
            );

          handlePillowProcess(
            color,
            finalPillowData,
            finalPreview,
            finalPreviewWithBg,
            finalDataUrl,
          );

          StatusManager.processStarted(task, {
            s3Url: finalS3Url,
            pillowData: finalPillowData,
            preview: finalPreview,
            previewWithBg: finalPreviewWithBg
          }, state, file);


        }).catch((error) => {
          handleProcessingError(error.message, 'start');
          UIService.hideAILoader();
        });
      } catch (error) {
        handleProcessingError(error.message, 'start');
        UIService.hideAILoader();
      }
    };

    const startFromHistory = (s3Url) => {
      try {
        if (!s3Url) {
          throw new Error('s3Url is required');
        }
        start(null, s3Url, null, true);
      } catch (error) {
        handleProcessingError(error.message, 'startFromHistory');
      }
    };

    // ============================================================================
    // Color Change Handler
    // ============================================================================
    const handleColorChange = (colorValue, source) => {
      try {
        // Validate color value
        if (!colorValue) {
          throw new Error('colorValue is required');
        }
        StateCoordinator.setColor(colorValue);
        StatusManager.colorStart(colorValue);

      } catch (error) {
        handleProcessingError(error.message, 'handleColorChange');
      }
    };

    // ============================================================================
    // Public API
    // ============================================================================
    return {
      start: (file, s3Url, dataUrl) => start(file, s3Url, dataUrl),
      startFromHistory: (params) => startFromHistory(params),
      colorChange: (colorValue, source) => handleColorChange(colorValue, source),
      markEventSuccess: (eventName, data) => StatusManager.markEventSuccess(eventName, data),
      markEventError: (eventName, errorType, data) => StatusManager.markEventError(eventName, errorType, data),
      error: (type) => StateCoordinator.error(type),
      setSaveToS3State: (status) => StateCoordinator.setSaveToS3State(status),
      getState: () => ({
        ...state
      }),
      initialState: () => StateCoordinator.initialState(),
    };
  })();

  // ============================================================================
  // Event Service
  // ============================================================================
  // Unified event management - handles all event dispatching and listening
  // ============================================================================
  const EventService = {
    dispatch: (eventName, detail = {}, state = null) => {
      const event = new CustomEvent(eventName, {
        bubbles: true,
        detail: {
          ...detail,
          state: state ? {
            ...state
          } : null
        }
      });
      document.dispatchEvent(event);
    },

    setupInternalHandlers: () => {
      $(document).on(EVENTS.PROCESSING_SUCCESS, (e) => {
        const { imageTask } = e.detail || {};
        if (!imageTask) return;

        if (!imageTask.historyId) {
          FileHistoryAdapter.createHistoryItem({
            id: imageTask.id,
            fileOriginalId: imageTask.fileOriginalId,
            color: imageTask.color,
            s3Url: imageTask.s3Url,
            pillowData: imageTask.pillowData,
            preview: imageTask.preview,
            previewWithBg: imageTask.previewWithBg || null
          });
        } else {
          FileHistoryAdapter.setCurrentFile(imageTask.id);
        }
      });
    },

    bindExternalEvents: () => {
      $(document).on('pillow3d:success', (e) => {
  
        const detail = e.originalEvent?.detail || {};
        const data = detail.data || detail || {};
        const {
          preview,
          previewWithBg,
          pillowData
        } = data;
        const colorEvent = detail.colorEvent || false;


        if (colorEvent) {
          
          ImageProcessingManager.setSaveToS3State(STATUS.SKIP);
        }
       
        ImageProcessingManager.markEventSuccess(EVENT_NAMES.PILLOW3D, {
          preview,
          previewWithBg,
          pillowData
        });
      });

      // Image upload success
      $(document).on('imageUploadInput:success', (e, payload) => {
        const data = payload || {};
        const target = String(data.target || '').trim();

        if (target && target !== PILLOW_TARGET) return;

        ImageProcessingManager.start(data.file || null, data.s3Url || null, data.dataUrl);
      });
    

      $(document).on('saveToS3:success', (e, eventData) => {
        const url = eventData?.url || eventData?.response?.url || null;

        ImageProcessingManager.markEventSuccess(EVENT_NAMES.SAVE_TO_S3, {
          url,
          ...eventData
        });
      });

      $(document).on('saveToS3:error', (e, errorData) => {
        // errorData contains: { error, errorType, message, ...eventData }
        const errorType = errorData?.errorType || 'network';
        console.log('SAVE TO S3 ERROR', errorData);
        
        ImageProcessingManager.markEventError(EVENT_NAMES.SAVE_TO_S3, errorType);
      });

      $(document).on('pillow3d:error', (event) => {
        const errorData = event.detail || event.originalEvent?.detail || {};
        
        if (!errorData?.error?.message) {
          ImageProcessingManager.markEventError(EVENT_NAMES.PILLOW3D, 'unknown');
          return;
        }
        const errorMsg = errorData.error.message.toLowerCase() || null;
        const errorType = errorMsg.includes('removebg') ? 'removebg' :
                         errorMsg.includes('background') ? 'removebg' :
                         errorMsg.includes('timeout') ? 'network' : 'mockup';

        ImageProcessingManager.markEventError(EVENT_NAMES.PILLOW3D, errorType);
      });

      function handleMockupHistoryLoadFile(e) {
        const {
          s3Url,
          imageType,
          color
        } = e.detail || {};
     
        if (!s3Url) return;
      
       
        ProductFormAdapter.updateColor(color, {
          source: 'mockupHistory'
        });
      
        ImageProcessingManager.startFromHistory(s3Url, imageType || 'image/jpeg');
      }

      $(document).on('mockupHistory:loadFile', handleMockupHistoryLoadFile);

      // UI Interactions
      $(document).on('click', '.js-main-shaped-secondary-action', (e) => {
        e.preventDefault();
        ImageUploadAdapter.open();
      });

      // Color change - listen to ProductFormCustom event
      $(document).on('productFormCustom:colorChange', (e) => {
        const {
          colorValue,
          source
        } = e.detail || {};
        
        if (colorValue && source !== 'mockupHistory') {
          ImageProcessingManager.colorChange(colorValue, source);
        }
      });
    }
  };





  // ============================================================================
  // Color Swatch Sync
  // ============================================================================
  function syncColorSwatchState() {
    const $colorInputs = $('[data-value-type="color"]');
    const $editBlockLabels = $('[data-color-label]');

    $(document).on('change', '[data-value-type="color"]', function () {
      const inputId = $(this).attr('id');
      if (!inputId) return;
      $editBlockLabels.removeClass('swatch-active');
      $editBlockLabels.filter(`[for="${inputId}"]`).addClass('swatch-active');
    });

    $colorInputs.filter(':checked').each(function () {
      const inputId = $(this).attr('id');
      if (inputId) {
        $editBlockLabels.filter(`[for="${inputId}"]`).addClass('swatch-active');
      }
    });
  }

  // ============================================================================
  // Analytics Event Handlers
  // ============================================================================
  // Separate analytics tracking that listens to processing events
  // ============================================================================
  const setupAnalyticsHandlers = () => {
    if (!window.AnalyticsModule) return; // Analytics not available, skip setup

    $(document).on('imageUploadInput:selected', (e) => {
      const detail = e.detail || {};
      const {
        file
      } = detail;
      const imageType = file?.type || null;

      const template = ProductFormAdapter.getCurrentTemplate();
      
      
      const product = ProductFormAdapter.getProductTitle();
      const productSku = ProductFormAdapter.getCurrentSku();

      AnalyticsAdapter.start({
        generationType: 'coloring',
        imageType: imageType,
        template: template,
        product: product,
        productSku: productSku,
        processType: EVENT_TYPES.FULL
      });
    });

    $(document).on(EVENTS.COLOR_INIT, (e) => {
      const template = ProductFormAdapter.getCurrentTemplate();
      const product = ProductFormAdapter.getProductTitle();
      const productSku = ProductFormAdapter.getCurrentSku();

      AnalyticsAdapter.start({
        generationType: 'coloring',
        template: template,
        product: product,
        productSku: productSku,
        processType: EVENT_TYPES.COLOR_CHANGE
      });

    });
    $(document).on(EVENTS.PROCESSING_INIT, (e) => {
      const detail = e.detail || {};
      const {
        file
      } = detail;
      const imageType = file?.type || 'image/jpeg';
      const fromHistory = detail.fromHistory || false;

      //skip if not from history
      if (!fromHistory) {
        return;
      }

      const template = ProductFormAdapter.getCurrentTemplate();
      const product = ProductFormAdapter.getProductTitle();
      const productSku = ProductFormAdapter.getCurrentSku();

      AnalyticsAdapter.start({  
        generationType: 'coloring',
        imageType: imageType,
        template: template,
        product: product,
        productSku: productSku,
        processType: EVENT_TYPES.HISTORY
      });

    });

    $(document).on('imageUploadInput:error', (e, payload) => {
      const data = payload || {};
      const target = String(data.target || '').trim();

      if (target && target !== PILLOW_TARGET) return;

      const errorMessage = data.error?.message || data.message || 'Unknown error';
      const error = {
        type: 'UNKNOWN',
        message: errorMessage
      };

      AnalyticsAdapter.endProcess('UNKNOWN', {
        error
      });
    });



    $(document).on(EVENTS.PROCESSING_SUCCESS, (e) => {
      const {
        imageTask
      } = e.detail || {};
      if (!imageTask) return;

      AnalyticsAdapter.endProcess('OK', {
        fileUrl: imageTask.s3Url || null,
        skipSave: imageTask.status?.saveToS3 === STATUS.SKIP,
        skipMockup: imageTask.status?.pillow3d === STATUS.SKIP
      });
    });

    $(document).on(EVENTS.PROCESSING_ERROR, (e) => {
      
      const {
        imageTask, errorType
      } = e.detail || {};
      if (!imageTask) return;

      const error = imageTask.error || null;
      AnalyticsAdapter.endProcess(errorType, {
        error,
        skipSave: imageTask.status?.saveToS3 === STATUS.SKIP,
        skipMockup: imageTask.status?.pillow3d === STATUS.SKIP
      });
    });


    $(document).on('pillow3d:start', (e) => {
      const detail = e.originalEvent?.detail || {};
      const colorEvent = detail.colorEvent || false;

      // Only track mockup start for new mockups, not color changes
      if (!colorEvent) {

        AnalyticsAdapter.startMockup();

      }
    });


    $(document).on('pillow3d:success', (e) => {
      const detail = e.originalEvent?.detail || {};
      const data = detail.data || detail || {};
      const {
        previewWithBg,
        preview
      } = data;
      const mockup = previewWithBg || preview;
      const colorEvent = detail.colorEvent || false;

      // Only track mockup end for new mockups, not color changes

      AnalyticsAdapter.endMockup(mockup, colorEvent);
     
    });

    $(document).on('saveToS3:success', (e, eventData) => {
      const url = eventData?.url || eventData?.response?.url || null;
      AnalyticsAdapter.endSave(url);
    });

    $(document).on('saveToS3:start', () => {
      setTimeout(() => {
        AnalyticsAdapter.startSave();
      }, 100);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.addedToCart, () => {
        AnalyticsAdapter.toCart();
      });
    }
  };

   // ============================================================================
  // Hide Product Block Handler
  // ============================================================================
  $(document).on('click', '[data-action="hide-product-block"]', function (e) {
    
    ImageProcessingManager.initialState();
  });

  // ============================================================================
  // Initialization
  // ============================================================================
  const createAnalyticsConfig = () => {
    return {
      templateName: $('[data-analytics-template]').attr('data-analytics-template') || '',
      productTitle: ProductFormAdapter.getProductTitle() ||
        $('[data-analytics-product-title]').attr('data-analytics-product-title') || '',
      getProductSku: () => ProductFormAdapter.getCurrentSku(),
      getAccessStatus: () => {
        return typeof window.accessCheck?.status === 'function' ?
          window.accessCheck.status() :
          true;
      }
    };
  };

  const initializeAnalytics = () => {
    const config = createAnalyticsConfig();
    const initialized = AnalyticsAdapter.init(config);

    if (!initialized) return;

    AnalyticsAdapter.setLogging(config.getAccessStatus());
    setupAnalyticsHandlers();
  };

  const initializeEventHandlers = () => {
    EventService.setupInternalHandlers();
    EventService.bindExternalEvents();
  };

  const initializeMainShaped = () => {
    // Prevent double initialization
    if (window.mainShapedInitialized) return;
    window.mainShapedInitialized = true;

    initializeAnalytics();
    initializeEventHandlers();
    syncColorSwatchState();
  };

  // Initialize - wait for FileHistoryManager if needed
  if (window.FileHistoryManager?.createHistoryItem) {
    initializeMainShaped();
  } else {
    $(window).on('fileHistoryManagerReady', initializeMainShaped);
    // Fallback: initialize after 1 second if FileHistoryManager still not ready
    setTimeout(() => {
      if (!window.mainShapedInitialized) {
        console.warn('[section-main-shaped] FileHistoryManager not ready, initializing anyway');
        initializeMainShaped();
      }
    }, 1000);
  }
})();

// ============================================================================
// Product Panel UI Handlers (Auto-initialized)
// ============================================================================
(() => {
  // Selectors
  const SELECTORS = {
    productPanel: '.product-panel',
    editPanel: '[data-panel-id]',
    productPanelInfo: '[data-info-panel]',
    editBlock: '[data-edit-block]',
    editBlockByAction: (action) => `[data-edit-block="${action}"]`,
    editBlockElement: '.edit-block',
    editOptionWrap: '.edit-option__wrap',
    editAction: '[data-edit-action]',
    editPanelOptions: '[data-edit-panel="options"]'
  };

  // Data attributes
  const DATA_ATTRS = {
    togglePanel: 'toggle-panel',
    closePanel: 'close-panel',
    editAction: 'edit-action',
    panelId: 'panel-id',
    infoPanel: 'info-panel',
    editBlock: 'edit-block',
    editPanel: 'edit-panel'
  };

  // CSS classes
  const CLASSES = {
    hide: 'hide',
    active: 'active'
  };

  // Action values
  const ACTIONS = {
    close: 'close',
    options: 'options'
  };

  // Helper: Get panel elements (only one panel exists)
  const getPanelElements = ($trigger) => {
    const $productPanel = $trigger.closest(SELECTORS.productPanel);
    return {
      $productPanel,
      $editPanel: $productPanel.find(SELECTORS.editPanel).first(),
      $productPanelInfo: $productPanel.find(SELECTORS.productPanelInfo).first()
    };
  };

  // Helper: Reset edit UI state
  const resetEditUI = ($editPanel) => {
    $editPanel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
    $editPanel.find(`${SELECTORS.editOptionWrap} ${SELECTORS.editAction}`).removeClass(CLASSES.active);
    $editPanel.find(SELECTORS.editPanelOptions).removeClass(CLASSES.hide);
  };

  // Helper: Show edit panel, hide info panel
  const showEditPanel = ($editPanel, $productPanelInfo) => {
    $editPanel.removeClass(CLASSES.hide).css('display', '');
    $productPanelInfo.addClass(CLASSES.hide);
  };

  // Helper: Hide edit panel, show info panel
  const hideEditPanel = ($editPanel, $productPanelInfo) => {
    $editPanel.addClass(CLASSES.hide);
    $productPanelInfo.removeClass(CLASSES.hide).css('display', '');
  };

  // ============================================================================
  // Panel Toggle Handlers
  // ============================================================================
  // Open edit panel
  $(document).on('click', `button[data-${DATA_ATTRS.togglePanel}]`, function (e) {
    e.preventDefault();
    const {
      $editPanel,
      $productPanelInfo
    } = getPanelElements($(this));
    if ($editPanel.length && $productPanelInfo.length) {
      showEditPanel($editPanel, $productPanelInfo);
    }
  });

  // Close edit panel and reset UI
  $(document).on('click', `button[data-${DATA_ATTRS.closePanel}]`, function (e) {
    e.preventDefault();
    const {
      $editPanel,
      $productPanelInfo
    } = getPanelElements($(this));
    if ($editPanel.length && $productPanelInfo.length) {
      resetEditUI($editPanel);
      hideEditPanel($editPanel, $productPanelInfo);
    }
  });

  // ============================================================================
  // Edit Panel Button Active State Handler
  // ============================================================================
  // Handle button active state in edit panel
  $(document).on('click', '[data-edit-panel] > button, [data-edit-panel] button', function (e) {
    const $button = $(this);
    const $editPanelContainer = $button.closest('[data-edit-panel]');
    
    if ($editPanelContainer.length) {
      // Remove active class from all buttons in the container
      $editPanelContainer.find('button').removeClass(CLASSES.active);
      // Add active class to clicked button
      $button.addClass(CLASSES.active);
    }
  });

  // ============================================================================
  // Edit Action Handlers
  // ============================================================================
  // Handle edit option buttons (open specific edit blocks)
  $(document).on('click', SELECTORS.editAction, function (e) {
    e.preventDefault();
    const action = String($(this).data(DATA_ATTRS.editAction) || '').trim();
    if (!action) return;

    const $button = $(this);
    
    // Find product panel first (works whether button is inside or outside edit panel)
    const $productPanel = $button.closest(SELECTORS.productPanel);
    if (!$productPanel.length) return;
    
    // Find edit wrap first, then use it to find the panel
    const $editWrap = $button.closest(SELECTORS.editOptionWrap);
    let $panel = null;
    
    if ($editWrap.length) {
      // If edit wrap exists, find panel through it
      $panel = $editWrap.closest(SELECTORS.editPanel);
    }
    
    // Fallback: try to find panel from button, or from product panel
    if (!$panel || !$panel.length) {
      $panel = $button.closest(SELECTORS.editPanel);
      if (!$panel.length) {
        // Button is outside edit panel - find the edit panel in the product panel
        $panel = $productPanel.find(SELECTORS.editPanel).first();
      }
    }
    
    if (!$panel || !$panel.length) return;
    
    // If edit panel is hidden, open it first
    if ($panel.hasClass(CLASSES.hide)) {
      const $productPanelInfo = $productPanel.find(SELECTORS.productPanelInfo).first();
      if ($productPanelInfo.length) {
        showEditPanel($panel, $productPanelInfo);
      }
    }
    
    const $optionsPanel = $panel.find(SELECTORS.editPanelOptions);

    // Close action: hide current edit block, show options panel
    if (action === ACTIONS.close) {
      const $editBlock = $button.closest(SELECTORS.editBlockElement);
      if ($editBlock.length) {
        $editBlock.addClass(CLASSES.hide);
      } else {
        // Button might be outside - hide all edit blocks
        $panel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
      }
      if ($editWrap.length) {
        $editWrap.find(SELECTORS.editAction).removeClass(CLASSES.active);
      } else {
        // Button might be outside - find edit wrap in panel
        $panel.find(SELECTORS.editOptionWrap).find(SELECTORS.editAction).removeClass(CLASSES.active);
      }
      $optionsPanel.removeClass(CLASSES.hide);
      return;
    }

    // Open action: hide options, show specific edit block
    $optionsPanel.addClass(CLASSES.hide);
    $panel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
    $panel.find(SELECTORS.editBlockByAction(action)).removeClass(CLASSES.hide);
    
    // Update active state on buttons
    if ($editWrap.length) {
      $editWrap.find(SELECTORS.editAction).removeClass(CLASSES.active);
    } else {
      // Button might be outside - find edit wrap in panel
      $panel.find(SELECTORS.editOptionWrap).find(SELECTORS.editAction).removeClass(CLASSES.active);
    }
    $button.addClass(CLASSES.active);
  });

 

  // ============================================================================
  // Hide Edit Panels Handler
  // ============================================================================
  $(document).on('click', '[data-action="hide-edit-panels"]', function (e) {
    e.preventDefault();

    // Hide edit panel and show info panel (only 1 panel exists)
    const $productPanel = $(SELECTORS.productPanel).first();
    const $editPanel = $productPanel.find(SELECTORS.editPanel).first();
    const $productPanelInfo = $productPanel.find(SELECTORS.productPanelInfo).first();
    
    if ($editPanel.length && $productPanelInfo.length) {
      resetEditUI($editPanel);
      hideEditPanel($editPanel, $productPanelInfo);
    }
  });

  // ============================================================================
  // Preview 3D Button Show/Hide Handler
  // ============================================================================
  // Show preview button when clicking on variant label
  $(document).on('click', '[data-form-variant-label]', function (e) {
    const $previewButton = $('[data-preview-3d-button]');
    if ($previewButton.length) {
      $previewButton.removeClass(CLASSES.hide);
    }
    
    // Shipping banner text switching based on size
    const $clickedLabel = $(this);
    let sizeValue = $clickedLabel.attr('data-size');
    // If not on label, check parent card
    if (!sizeValue) {
      sizeValue = $clickedLabel.closest('.vpc-card').attr('data-size');
    }
    const $defaultText = $('[data-text="default"]');
    const $xLargeText = $('[data-text="x-large"]');
    
    if (sizeValue && sizeValue.toLowerCase() === 'x-large') {
      $defaultText.addClass(CLASSES.hide);
      $xLargeText.removeClass(CLASSES.hide);
    } else {
      $defaultText.removeClass(CLASSES.hide);
      $xLargeText.addClass(CLASSES.hide);
    }
  });

  

})();